import(/* webpackMode: "eager" */ "/vercel/path0/src/app/personal-banking/page.jsx");
